import { render, staticRenderFns } from "./acvicity-form.vue?vue&type=template&id=c1834dfc&scoped=true"
import script from "./acvicity-form.vue?vue&type=script&lang=js"
export * from "./acvicity-form.vue?vue&type=script&lang=js"
import style0 from "./acvicity-form.vue?vue&type=style&index=0&id=c1834dfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1834dfc",
  null
  
)

export default component.exports